/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Registered_AddressInputs */

const en_reference_field_registered_address = /** @type {(inputs: Reference_Field_Registered_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered address`)
};

/**
* | output |
* | --- |
* | "Registered address" |
*
* @param {Reference_Field_Registered_AddressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_registered_address = /** @type {((inputs?: Reference_Field_Registered_AddressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Registered_AddressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_registered_address(inputs)
});